import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Grid,
  Alert,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { get, post } from "src/utils/networkUtils";

export default function CodesListPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(null);
  const [totals, setTotals] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    get(`/admin/custom-codes?offset=0&limit=2000`).then(function (response) {
      setRows(response.codes);
      setTotals(response.totals ?? []);
    });
  }, [setSearchParams, searchParams, navigate]);

  const uploadCodes = (event) => {
    if (event.target.files.length > 0) {
      setLoading(true);
      const files = event.target.files;

      const bodyFormData = new FormData();
      bodyFormData.append("file", files[0]);

      post(`/admin/custom-codes`, bodyFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      }).then(function (response) {
        window.location.reload(false);
      });
    }
  };
  return (
    <>
      <Helmet>
        <title> Custom Codes </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="h4" gutterBottom>
            Custom Codes
          </Typography>
          <Button color="primary" aria-label="upload picture" component="label">
            <input
              hidden
              accept="text/csv"
              type="file"
              onChange={(event) => uploadCodes(event)}
            />
            <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
            Upload Codes
          </Button>
        </Stack>

        <Grid container>
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Alert sx={{ marginBottom: 2 }} severity="info">
              Codes left:{" "}
              {totals !== null &&
                totals.map((total, index) => (
                  <span key={index}>
                    {total.amount}: {total.count},{" "}
                  </span>
                ))}
            </Alert>
          </Grid>
        </Grid>
        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Code ID</TableCell>
                      <TableCell>Code</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Used</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.codeId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.code}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.amount}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.usedAt !== null ? (
                            <>
                              <Iconify
                                icon={"eva:checkmark-circle-2-outline"}
                                sx={{ color: "green" }}
                              />
                            </>
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
    </>
  );
}
